import React from 'react'
import { connect } from 'react-redux'
import {compose } from 'recompose'
import * as routes from '../../../constants/routes';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Badge from '@material-ui/core/Badge';
import Contacts from '@material-ui/icons/Contacts';
import { styles } from '../../../js/settings/styles'
import {getDateFormated} from '../../../js/helper'
import { CURRENT_OPEN_EVENT } from '../../../constants/actionTypes';

const AdminEventListItem = (props) =>{
    
const { classes, event, canidates, history, setCurrentOpenEvent } = props
const { data, requester } = event
const colorState = {}
 
const getCanidatesCount = () => {
    if(canidates!=null){
       if(Object.keys(canidates))
        colorState.badge = 'primary'
        return Object.keys(canidates).length
    }
        colorState.badge = 'secondary'
        return '0'
}
//---------------------------------------------

    const handleClick = () => {
        if(canidates!=null) {
            const currentOpenEvent = {
                requester: requester,
                event: data,
                canidates: canidates
            }
            setCurrentOpenEvent(currentOpenEvent)
            history.push(routes.ADMINEVENTDETAILS_WITH_CANIDATES)
        } else {
            const currentOpenEvent = {
                requester: requester,
                event: data,
            }
            setCurrentOpenEvent(currentOpenEvent)
            history.push(routes.ADMINEVENTDETAILS_WITHOUT_CANIDATES)
        }
    }

    const renderHeader = (
        <div className={classes.header}>
        <Typography color='inherit' variant='subheading'>
            <div className={classes.requester.name}>{requester.name}</div>
        </Typography>
    </div>)

    const renderBody = (
        <div className={classes.body}>
            <Typography variant='body2'>
                <div className={classes.row}>sucht für {data.task} </div>
                <div className={classes.row}>in {data.ort}</div>
            </Typography>
        
            <Typography variant='body2'>
                {event.timeRange==='onData'
                            ? <span style={styles.red}>An einem bestimmten Datum</span>
                            : <span>Nach Vereinbarung bis: </span>
                }
                <div style={{fontSize: '1.2em', fontWeight: 'bold'}}>{getDateFormated(data.date, 'withWeekDay')}</div>
            </Typography>
        </div>  
    )


    const renderFooter = (
        <div className={classes.paperFooter}>
            <div className={classes.timeLeft }>
                Läuft ab in {getDateFormated(data.date, 'untilThen')}
            </div>
            <div style={{display: 'inline-block'}}>
                <Badge badgeContent={getCanidatesCount(data.id)} color={colorState.badge}>
                    <Contacts color={'primary'}/>
                </Badge>
            </div>
            </div>
    )
    return (
        <Card 
            className={classes.card}
            onClick={()=>handleClick()}
        >
            {renderHeader}
            {renderBody}
            {renderFooter}
        </Card>
    )
}

const mapStateToProps = (state) => ({

})

const mapDispatchToProps = (dispatch) =>({
    setCurrentOpenEvent: (payload)=>dispatch({type: CURRENT_OPEN_EVENT, payload})
 })
 
export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    withStyles(styles)
)(AdminEventListItem)


// WEBPACK FOOTER //
// ./src/Container/Content/AdminEvents/AdminEventListItem.js